import { isBlock, isBr, isElement, isText } from "../helpers";
import type { TableCell, TableNode } from "../types";
import { parsePair } from "./pair";

const cellText = (cell: Element) => {
  const pieces: string[] = [];
  let current = "";
  const flush = () => {
    const text = current.replace(/\s+/g, " ").trim();
    if (text) pieces.push(text);
    current = "";
  };
  const walk = (node: Node) => {
    node.childNodes.forEach((child) => {
      if (isText(child)) {
        current += child.data;
      } else if (isBr(child)) {
        flush();
      } else if (isBlock(child)) {
        flush();
        walk(child);
        flush();
      } else if (isElement(child)) {
        walk(child);
      }
    });
  };
  walk(cell);
  flush();
  return pieces.join("\n");
};

const parseCell = (cell: HTMLTableCellElement): TableCell => {
  const text = cellText(cell);
  const parsed: TableCell = {
    type: cell.tagName === "TH" ? "th" : "td",
    text,
    colSpan: cell.colSpan || 1,
    rowSpan: cell.rowSpan || 1,
  };
  const pair = parsePair(text);
  if (pair) parsed.pair = pair;
  return parsed;
};

const parseTable = (table: HTMLTableElement): TableNode => ({
  type: "table",
  level: 0,
  rows: Array.from(table.rows).map((row) => ({
    cells: Array.from(row.cells).map(parseCell),
  })),
});

export { parseTable };
